import { axiosSecureInstance } from "./axios";
import { getUserID } from "../Utility/service";
import {
  LEADSLIFT,
  LEADSLIFT_USER_BASED_KEY_SLUG,
} from "../constants/Api_constants";

export const connectLeadsLift = async (
  leadsLiftToken,
  leadsLiftLocationId,
  leadsLiftUserId
) => {
  try {
    const userId = getUserID();
    const body = {
      userId,
      leadsLiftToken,
      leadsLiftLocationId,
      leadsLiftUserId,
    };
    const response = await axiosSecureInstance.post(`${LEADSLIFT}`, body);
    localStorage.setItem("leadsLiftConnected", true);
    localStorage.setItem("leadsLiftLocationId", leadsLiftLocationId);

    if (response?.status === 200) {
      return response?.data;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export const getLeadsLiftCredentials = async (setIsLeadsLiftConnected) => {
  try {
    const userId = getUserID();
    const response = await axiosSecureInstance.get(
      LEADSLIFT_USER_BASED_KEY_SLUG(userId)
    );

    if (response?.status === 200) {
      setIsLeadsLiftConnected(true);
      localStorage.setItem("leadsLiftConnected", true);
      localStorage.setItem(
        "leadsLiftLocationId",
        response?.data?.leadsLiftLocationId
      );
      return true;
    } else {
      setIsLeadsLiftConnected(false);
      return null;
    }
  } catch (error) {
    console.error("Error fetching Leadslift credentials:", error);
    setIsLeadsLiftConnected(false);
    return error;
  }
};

export const deleteLeadsLiftKeysFromDB = async () => {
  try {
    const userId = getUserID();
    const response = await axiosSecureInstance.delete(
      LEADSLIFT_USER_BASED_KEY_SLUG(userId)
    );

    if (response?.status === 200) {
      localStorage.removeItem("leadsLiftConnected");
      localStorage.removeItem("leadsLiftLocationId");
      return { success: response?.data?.message };
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error deleting LeadsLift keys:", error);
    const errorMessage = error?.response?.data?.message;
    return { error: errorMessage };
  }
};
